<template>
    <div class="position-relative searchable-select-container" ref="selectContainer">
        <!-- BOTÃO GATILHO (COM MESMO TAMANHO E ESTILO DOS INPUTS MODERNOS) -->
        <button type="button"
            class="form-select-pmg-modern text-uppercase d-flex align-items-center justify-content-between w-100"
            :class="{ 'opacity-50': disabled, 'is-open': isOpen }" 
            :disabled="disabled" 
            @click="toggleDropdown">
            <span class="text-truncate" :class="{ 'text-muted text-transform-none fw-normal': !modelValue }">
                {{ modelValue || placeholder }}
            </span>
            <i class="bi bi-chevron-down ms-2 fs-7 text-muted transition-transform" :class="{ 'rotate-180': isOpen }"></i>
        </button>

        <!-- MENU SUSPENSO COM CAMPO DE BUSCA -->
        <div v-if="isOpen" class="dropdown-menu show w-100 p-2 shadow-lg rounded-3 mt-1 border-0"
            style="max-height: 280px; overflow-y: auto; z-index: 1050; background-color: #ffffff;">

            <!-- CAMPO DE PESQUISA -->
            <div class="input-group input-group-sm mb-2 sticky-top bg-white pt-1">
                <span class="input-group-text bg-light border-end-0 text-muted">
                    <i class="bi bi-search"></i>
                </span>
                <input ref="searchInput" type="text" class="form-control form-control-sm border-start-0 bg-light"
                    placeholder="Pesquisar..." v-model="searchQuery" @click.stop />
            </div>

            <!-- LISTA DE OPÇÕES FILTRADAS -->
            <ul class="list-unstyled mb-0">
                <li v-for="option in filteredOptions" :key="option"
                    class="dropdown-item-custom small text-uppercase py-2 px-3 rounded-2 cursor-pointer transition-all"
                    :class="{ 'active-option': option === modelValue }" @click="selectOption(option)">
                    {{ option }}
                </li>
                <li v-if="filteredOptions.length === 0" class="text-muted small text-center py-2 fs-7">
                    Nenhuma categoria encontrada
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SearchableSelect',
    props: {
        modelValue: {
            type: String,
            default: ''
        },
        options: {
            type: Array,
            required: true
        },
        placeholder: {
            type: String,
            default: 'SELECIONE UMA OPÇÃO...'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    emits: ['update:modelValue'],
    data() {
        return {
            isOpen: false,
            searchQuery: ''
        };
    },
    computed: {
        filteredOptions() {
            if (!this.searchQuery) return this.options;
            const query = this.searchQuery.toLowerCase();
            return this.options.filter(opt => opt.toLowerCase().includes(query));
        }
    },
    methods: {
        toggleDropdown() {
            if (this.disabled) return;
            this.isOpen = !this.isOpen;

            if (this.isOpen) {
                this.searchQuery = '';
                this.$nextTick(() => {
                    if (this.$refs.searchInput) {
                        this.$refs.searchInput.focus();
                    }
                });
            }
        },
        selectOption(option) {
            this.$emit('update:modelValue', option);
            this.isOpen = false;
        },
        handleClickOutside(event) {
            if (this.$refs.selectContainer && !this.$refs.selectContainer.contains(event.target)) {
                this.isOpen = false;
            }
        }
    },
    mounted() {
        document.addEventListener('click', this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
};
</script>

<style scoped>
/* ESTILIZAÇÃO IDÊNTICA AOS INPUTS MODERNOS */
.form-select-pmg-modern {
    padding: 0.65rem 1rem !important;
    font-size: 0.925rem !important;
    border-radius: 12px !important;
    border: 1px solid #e2e8f0 !important;
    background-color: #ffffff;
    color: #1e293b;
    transition: all 0.2s ease-in-out;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
    text-align: left;
    cursor: pointer;
}

.form-select-pmg-modern:focus,
.form-select-pmg-modern.is-open {
    border-color: #5F0487 !important;
    box-shadow: 0 0 0 4px rgba(95, 4, 135, 0.12) !important;
    outline: none;
}

.form-select-pmg-modern:disabled {
    background-color: #f8fafc !important;
    border-color: #e2e8f0 !important;
    color: #64748b !important;
    cursor: not-allowed;
    opacity: 0.85;
}

.rotate-180 {
    transform: rotate(180deg);
}

.transition-transform {
    transition: transform 0.2s ease;
}

.cursor-pointer {
    cursor: pointer;
}

.transition-all {
    transition: all 0.15s ease-in-out;
}

.dropdown-item-custom {
    color: #334155;
}

.dropdown-item-custom:hover {
    background-color: #f1f5f9;
    color: #5F0487;
    font-weight: 600;
}

.active-option {
    background-color: #5F0487 !important;
    color: #ffffff !important;
    font-weight: 600;
}

.text-transform-none {
    text-transform: none !important;
}
</style>